import React, { Component } from 'react';
import './InspirationContainer.module.scss';

import {inspirationData} from 'utilities/Inspiration';

import Label from 'components/UI/Label/Label';
import ButtonRight from 'components/UI/ButtonRight/ButtonRight';
import DownloadButtonRight from 'components/UI/download-button/DownloadButtonRight/DownloadButtonRight';


class InspirationContainer extends Component {

    constructor() {
        super();

        this.closeModal = this.closeModal.bind(this);
    }

    closeModal() {
        this.props.closeModal();
    }

    render() {

        var {inspirationId} = this.props
        
        const inspiration = inspirationData[inspirationId];

        let slug = inspiration.name.split(" ").join("-").toLowerCase();

        return (
            <div styleName='contentcontainer'>
                <div onClick={this.closeModal} styleName='bluepoly'></div>
                <div onClick={this.closeModal} styleName='pinkpoly'></div>
                <div onClick={this.closeModal} styleName='yellowpoly'></div>
                <div styleName='popupimage' style={{backgroundImage: `url(/images/inspiration/${slug}.jpg`}}>

                </div>
                <div styleName='popupcontent'>
                    <div styleName='title-wrapper'>
                        <div styleName='content-tile-left'>
                            <h3>{inspiration.name}</h3>
                        </div>
                        <div styleName='title-right'>
                            {
                            slug != 'stuur-je-eigen-creatie-in' &&
                                <p>{inspiration.owner}</p>
                            }
                            <p>{inspiration.date}</p>
                        </div>
                        </div>
                        <p styleName='informationbold'>
                            {inspiration.informationbold}
                        </p >
                        <p dangerouslySetInnerHTML={{__html: inspiration.information}}>

                        </p>
                    {
                        slug != 'stuur-je-eigen-creatie-in' &&
                        <DownloadButtonRight text='Download bestanden' link={`/storage/inspiration/${slug}.zip`}></DownloadButtonRight>
                    }
                    
                </div>
            </div>
        );  
    }
}

export default InspirationContainer;


// WEBPACK FOOTER //
// ./resources/assets/components/UI/ModalContainer/components/InspirationContainer/InspirationContainer.jsx